import React, { Fragment, useState } from 'react'
import {Row, Col} from 'react-bootstrap';

import './PortalItem.css'
import {ButtonPortal} from '../../component/Button/ButtonPortalItem'
import {getColor, inProgressColor, PortalWifiIcon} from "../Icon/WifiIcon";
import {dayMonthYearAtTimeWithSeconds} from "../../utils/dates";
import { ButtonHeader } from '../../component/Button/ButtonHeader'
import Icon from "../Icon/Icon";
import { ModalMessage } from '../Modal/ModalMessage'

const CartText = ({title, icon, color, style}) => {
  return (
      <Row style={style} className="justify-content-center justify-self-start align-items-center w-100 ml-5 p-2">
        <Col md={1} sm={1} lg={1} xs={1}>
          <Icon icon={icon} style={{color: color}}/>
        </Col>
        <Col md={10} sm={10} lg={10} xs={10}>
          <div>{title}</div>
        </Col>
      </Row>
  );
}

export const PortalItem = ({history, portal}) => {

  const {id, name, nodeDetail, transactionTarget, readpointCheckpointTarget} = portal;
  const isOnline = nodeDetail && nodeDetail.online;
  const lastPingDate = nodeDetail && nodeDetail.dateLastPing;
  const dateInitOperation = transactionTarget && transactionTarget.createdAt;
  const [showModal, setShowModal] = useState(false)

  const successButtonAction = () => {
    const prefix = `/portals/readpoints/${id}`;
    if (isOnline && !transactionTarget) {
      history.push(`${prefix}/checkpoints`)
    } else {
      history.push(`${prefix}/transactions`)
    }
  }

  return (
      <Row className="card justify-content-around mr-5 mt-5">
        <Row className="justify-content-center align-items-center">
          <Col md={2} sm={2} lg={2}>
            <PortalWifiIcon prefixIcon="wifi fa-2x" isOnline={isOnline} transactionTarget={transactionTarget}/>
          </Col>
          <Col md={6} sm={6} lg={6} className="justify-content-center mr-4">
            <h5 className="text-center">Portal RFID:</h5>
            <h4 id="titleCard">{name}</h4>
          </Col>
          <Col md={2} sm={2} lg={2} className="align-self-start">
            <ButtonHeader 
              style={{border: 'none', background: 'none'}} 
              icon="cog fa-lg" 
              iconStyle={{color: 'gray', backgroundColor: 'none'}}
              onClick={() => history.push(`/automatic/portals/${id}`)}
            />
          </Col>
        </Row>
        <Row className="ml-4">
          <CartText
            style={{marginTop: transactionTarget ? '-100' : null}}
            title={`${isOnline ? 'Online' : 'Offline'} ${!lastPingDate ? 'Data não encontrada' : dayMonthYearAtTimeWithSeconds(lastPingDate)}`}
            icon={`${isOnline ? 'check' : 'exclamation'}-circle`}
            color={isOnline ? 'green' : 'red'}
          />
          {transactionTarget ?
            <Fragment>
              <CartText
                title={dayMonthYearAtTimeWithSeconds(dateInitOperation)}
                icon={'undo'}
                color={inProgressColor}
              />
              <CartText
                title={transactionTarget.userUpdatedBy ? transactionTarget.userUpdatedBy.name : 'Usuário não encontrado'}
                icon={'user-circle'}
              />
            </Fragment>
            : null}
            {
              readpointCheckpointTarget && readpointCheckpointTarget.canDoAutomaticTransaction ? 
              <CartText
                title={readpointCheckpointTarget.checkpoint && readpointCheckpointTarget.checkpoint.friendlyName ? readpointCheckpointTarget.checkpoint.friendlyName : 'Portal automático sem nome'}
                icon={'podcast'}
                color={'gray'}
              /> : null
            }
        </Row>
        <Row className={`d-flex justify-content-center ${transactionTarget ? 'mb-3' : null}`}>
          <Col>
            <ButtonPortal
              onClick={() => successButtonAction() }
              disabled={!isOnline && !transactionTarget || readpointCheckpointTarget && readpointCheckpointTarget.canDoAutomaticTransaction } 
              className="portal-button"
              style={{
                backgroundColor: getColor(isOnline, transactionTarget)
              }}
              text={
                (isOnline && !transactionTarget ? 'Iniciar Operação' : null) ||
                (isOnline && transactionTarget ? 'Ver detalhes...' : null) ||
                (!isOnline && transactionTarget ? 'Ver detalhes...' : null) ||
                (!isOnline && !transactionTarget ? 'Iniciar Operação' : null)
              }
            />
          </Col>
        </Row>
        {/* <ModalMessage 
          showModal={showModal} 
          handleShowModal={setShowModal} 
          successButtonAction={successButtonAction}
          title="Deseja iniciar uma operação manual em um portal automático?"
        /> */}
      </Row>
  )
}



// WEBPACK FOOTER //
// ./src/component/PortalList/PortalItem.js